import React, {useMemo} from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';

import {
  RoleAvatar,
  TeamAvatar,
  UserAvatar,
} from 'app/components/general/avatars';
import {MultipleAssignedAvatar} from 'app/components/general/avatars/MultipleAssignedAvatar';
import {HeadingText} from 'app/components/general/HeadingText';
import {gt} from 'app/utils/i18n';

import {
  BasicRoleSerializedType,
  BasicTaskUserSerializedType,
  BasicTeamSerializedType,
} from 'sweet-types';

type AssignableType =
  | BasicTeamSerializedType
  | BasicTaskUserSerializedType
  | BasicRoleSerializedType;

const VISIBLE_AVATARS = 5;

interface Props {
  stepAssignments: Array<AssignableType>;
}

export const StepAssignmentAvatars = ({stepAssignments}: Props) => {
  if (stepAssignments.length === 0) {
    return null;
  }

  let splitAssignments: {
    visible: Array<AssignableType>;
    hidden: Array<AssignableType>;
  } = useMemo(() => {
    return {
      visible: stepAssignments.slice(0, VISIBLE_AVATARS),
      hidden: stepAssignments.slice(VISIBLE_AVATARS),
    };
  }, [stepAssignments]);

  return (
    <StyledContainerDiv className="mb-2 d-flex justify-content-end align-items-center p-2">
      <HeadingText size="75%" className="m-1" style={{lineHeight: '0.75'}}>
        {gt('Assigned to')}
      </HeadingText>
      {splitAssignments.visible.map((assignment) => {
        if (assignment.content_type === 'user') {
          return (
            <UserAvatar
              key={'user-' + assignment.id}
              className="ml-1"
              showCard
              user={assignment}
              isGuest={assignment.is_guest_until != null}
            />
          );
        }
        if (assignment.content_type === 'team') {
          return (
            <div className="ml-1" key={'team-' + assignment.id}>
              <TeamAvatar link={true} team={assignment} />
            </div>
          );
        }
        if (assignment.content_type === 'role') {
          return (
            <div className="ml-1" key={'role-' + assignment.id}>
              <RoleAvatar link={true} role={assignment} />
            </div>
          );
        }
      })}
      {splitAssignments.hidden.length > 0 ? (
        <MultipleAssignedAvatar
          className="ml-1"
          usersAndTeamsAndRoles={splitAssignments.hidden}
          tooltipTitle={gt('Further assignments')}
        />
      ) : null}
    </StyledContainerDiv>
  );
};

const StyledContainerDiv = styled.div`
  background-color: ${colors.lightBg};
  border-radius: 5px;
  border-left: 4px solid ${colors.mediumGray};
`;
